import React from 'react';

function Filter(props: object) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.5"
        d="M18 9.49954H6.64676M6.64676 9.49954C6.64676 10.0259 6.43478 10.5307 6.0591 10.9029C5.68342 11.2751 5.17389 11.4842 4.64259 11.4842C4.1113 11.4842 3.60177 11.2751 3.22609 10.9029C2.85041 10.5307 2.63935 10.0259 2.63935 9.49954M6.64676 9.49954C6.64676 8.97319 6.43478 8.46839 6.0591 8.09619C5.68342 7.724 5.17389 7.51491 4.64259 7.51491C4.1113 7.51491 3.60177 7.724 3.22609 8.09619C2.85041 8.46839 2.63935 8.97319 2.63935 9.49954M2.63935 9.49954H1M18 15.5145H12.7181M12.7181 15.5145C12.7181 16.0409 12.5065 16.5463 12.1307 16.9186C11.755 17.2909 11.2453 17.5 10.7139 17.5C10.1826 17.5 9.67307 17.29 9.29739 16.9178C8.9217 16.5456 8.71065 16.0408 8.71065 15.5145M12.7181 15.5145C12.7181 14.988 12.5065 14.4835 12.1307 14.1112C11.755 13.739 11.2453 13.5298 10.7139 13.5298C10.1826 13.5298 9.67307 13.7389 9.29739 14.1111C8.9217 14.4833 8.71065 14.9881 8.71065 15.5145M8.71065 15.5145H1M18 3.48464H15.1468M15.1468 3.48464C15.1468 3.74526 15.094 4.00334 14.9933 4.24413C14.8927 4.48491 14.7451 4.7037 14.5591 4.88799C14.3731 5.07228 14.1522 5.21847 13.9092 5.3182C13.6662 5.41794 13.4057 5.46927 13.1426 5.46927C12.6113 5.46927 12.1018 5.26018 11.7261 4.88799C11.3504 4.5158 11.1394 4.011 11.1394 3.48464M15.1468 3.48464C15.1468 3.22401 15.094 2.96594 14.9933 2.72515C14.8927 2.48436 14.7451 2.26558 14.5591 2.08129C14.3731 1.897 14.1522 1.75081 13.9092 1.65107C13.6662 1.55133 13.4057 1.5 13.1426 1.5C12.6113 1.5 12.1018 1.7091 11.7261 2.08129C11.3504 2.45348 11.1394 2.95828 11.1394 3.48464M11.1394 3.48464H1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Filter;
